<template>
    <div class="mains">
      <el-dialog :close-on-click-modal="false"
          title="批量下单"
          :visible.sync="orderingFlow"
          :before-close="Close"
          width="840px"
          center
          top="15vh"
          v-loading="loading"
          element-loading-text="拼命加载中"
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(0, 0, 0, 0.8)"
        >
          <el-divider></el-divider>
          <div class="boxs">
              <div class="boxs_input">
                  <div>
                    <span>产品名称：</span>
                    <el-input placeholder="请输入产品名称" v-model="row.ProductName" disabled></el-input>
                  </div>
                  <div>
                    <span>产品ID：</span>
                    <el-input placeholder="请输入产品ID" v-model="row.ProductID" disabled></el-input>
                  </div>
              </div>
              <div class="xls" v-if="flow"> 
                <span>使用期：</span>
                <el-date-picker v-model="valueTime" type="date" placeholder="选择日期"  value-format="yyyy-MM-dd" ></el-date-picker>
              </div>
              <div class="xls">
                <span>名单表：</span>
                <el-upload
                  class="upload-demo"
                  drag
                  action="http://xwt.softykt.net/api/res/addBatchFile"
                  :on-success="attachUploadSuccess"
                  multiple>
                    <div>
                      {{flowlist?'已上传文件':'+   点击上传'}}
                    </div>
                </el-upload>
                
                <span @click="uploadXls">下载表格模版.xls</span>
              </div>
              <div class="remaker">
                <span>备注：</span>
                <el-input type="textarea" v-model="remark"
                :autosize="{ minRows: 4, maxRows: 4}"
                placeholder="请输入内容"></el-input>
              </div>
              <div class="btns_box">
                <div @click="piliangClick"  >确认下单</div>
              </div>
          </div>
      </el-dialog>
    </div>
</template>
<script>
import { Message, MessageBox } from 'element-ui'
import { addDistributorBatchOrder } from '@/request/distributor.js'
export default {
  data(){
    return{
      orderingFlow:false,
      row:'',
      valueTime:'',
      remark:'',
      flow:false,
      flowlist:false,
      path:'',
      fullscreenLoading: false,
      loading:true
    }
  },
  methods:{
    piliangClick(){
      let diskey = window.sessionStorage.getItem('diskey') || ''
      if(!diskey){
        MessageBox.confirm('分销商秘钥不能为空，请生成秘钥！', '提示', {
          confirmButtonText: '去生成',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$router.push({ path: '/fxWorke' })
        }).catch(() => {})
        return false
      }
      if(this.row.type=='1'){
        if(this.valueTime==''){
          Message.error('请选择时间')
          return false
        }
      }
      if(this.path==''){
        Message.error('请上传文件')
          return false
      }
      let data = {
        token:window.sessionStorage.getItem('Token'),
        goods_id:this.row.ProductID,
        scenicid:this.row.ScenicID,
        user_code:window.sessionStorage.getItem('user_code'),
        diskey:window.sessionStorage.getItem('diskey'),
        path:this.path,
        playdate:this.valueTime,
        remark:this.remark
      }
      const loading = this.$loading({
        lock: true,
        text: '批量下单中请稍后前往批量订单列表查看',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      setTimeout(() => {
        loading.close();
        this.orderingFlow = false;
      }, 2000);
      addDistributorBatchOrder(data).then(res=>{
        if(res.data.rcode==200){
          // Message.success('批量下单成功')
          this.$emit('close')
          this.valueTime = ''
          this.path = ''
          this.loading = true
        }else{
          Message.error(res.data.msg)
        }
      })
    },
    uploadXls(){
      if(this.flow){
        // 日历票模板
        window.location.href =  'https://jinfeiying.oss-cn-beijing.aliyuncs.com/Res/%E6%97%A5%E5%8E%86%E7%A5%A8%E4%B8%8B%E5%8D%95%E7%94%A8%E6%88%B7%E4%BF%A1%E6%81%AF.xls'
      }else {
        // 期票模板
        window.location.href =  'https://jinfeiying.oss-cn-beijing.aliyuncs.com/Res/%E6%9C%9F%E7%A5%A8%E4%B8%8B%E5%8D%95%E7%94%A8%E6%88%B7%E4%BF%A1%E6%81%AF.xls'
      }
    },
    attachUploadSuccess(e){
      this.flowlist = true
      this.path = e.result
    },
    proInfo(row){
      console.log(row)
      this.flowlist = false
      this.orderingFlow = true
      this.path = ''
      this.row = row
      if(row.type==1){
        // 日历
        this.flow = true
      }else{
        this.flow = false
      }
    },
    Close(){
      this.orderingFlow = false;
      this.$emit('close')
      this.valueTime = ''
      this.path = ''
      this.fullscreenLoading = false
    }
  }
}
</script>
<style lang="less" scoped>
.boxs_input{
  display: flex;
  align-items: center;
  >div{
    display: flex;
    align-items: center;
    >span{
      color: #666666;
      font-size: 1.4rem;
      display: block;
      width: 10rem;
      text-align: right;
    }
    &:nth-child(1){
      ::v-deep .el-input{
        width: 40rem ;
      }
    }
    &:nth-child(2){
      ::v-deep .el-input{
        width: 20rem ;
      }
    }
    ::v-deep .el-input__inner{
      border-color: #E5E5EA;
      background: #FFFFFF;
    }
  }
}
.xls{
  display: flex;
  align-items: center;
  margin-top: 2rem;
  div{
    width: 16rem;
    height: 4rem;
    border-radius: 0.4rem;
    background: #E1E1E1;
    font-size: 1.4rem;
    color: #666666;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }
  >span{
    &:nth-child(1){
      display: block;
      width: 10rem;
      text-align: right;
      color: #666666;
      font-size: 1.4rem;
    }
    &:nth-child(3){
      color: #246DEB;
      display: block;
      margin-left: 1rem;
      font-size: 1.4rem;
      text-decoration: underline;
      cursor: pointer;
    }
  }
  ::v-deep .el-date-editor{
    width: 70rem;
  }
}
.remaker{
  display: flex;
  align-items: center;
  margin-top: 2rem;
  >span{
    &:nth-child(1){
      display: block;
      width: 10rem;
      text-align: right;
      color: #666666;
      font-size: 1.4rem;
    }
  }
  ::v-deep .el-textarea{
    width: 70rem;
  }
  ::v-deep .el-textarea__inner{
    resize: none;
  }
}
.btns_box{
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 4rem;
  >div{
    width: 10rem;
    height: 4rem;
    border-radius: 0.4rem;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    font-size: 1.4rem;
    cursor: pointer;
    background: #246DEB;
  }
}
::v-deep .upload-demo{
  width: 16rem ;
  height: 4rem;
}
::v-deep .el-upload-dragger{
  width: 100%;
  height: 100%;
  border: none;
}
::v-deep .el-upload-list{
  display: none;
}
</style>
